import c0 from './range_controller';
import c1 from './refresh_controller';
import c2 from './image_upload_controller';
import c3 from './password_check_controller';
import c4 from './query_controller';
import c5 from './rich_text_area_controller';
import c6 from './password_visibility_controller';
import c7 from './popup_controller';
import c8 from './sortable_controller';
import c9 from './clipboard_controller';
import c10 from './select_controller';
import c11 from './screenshot_controller';
import c12 from './scroll_to_controller';
import c13 from './nested_form_controller';
import c14 from './autocomplete_controller';
import c15 from './richtext_controller';
import c16 from './modal_controller';
import c17 from './sync_width_controller';
import c18 from './forms/dependend_field_visibility_controller';
import c19 from './autosubmit_controller';
import c20 from './tooltip_controller';
export const definitions = [
	{identifier: 'range', controllerConstructor: c0},
	{identifier: 'refresh', controllerConstructor: c1},
	{identifier: 'image-upload', controllerConstructor: c2},
	{identifier: 'password-check', controllerConstructor: c3},
	{identifier: 'query', controllerConstructor: c4},
	{identifier: 'rich-text-area', controllerConstructor: c5},
	{identifier: 'password-visibility', controllerConstructor: c6},
	{identifier: 'popup', controllerConstructor: c7},
	{identifier: 'sortable', controllerConstructor: c8},
	{identifier: 'clipboard', controllerConstructor: c9},
	{identifier: 'select', controllerConstructor: c10},
	{identifier: 'screenshot', controllerConstructor: c11},
	{identifier: 'scroll-to', controllerConstructor: c12},
	{identifier: 'nested-form', controllerConstructor: c13},
	{identifier: 'autocomplete', controllerConstructor: c14},
	{identifier: 'richtext', controllerConstructor: c15},
	{identifier: 'modal', controllerConstructor: c16},
	{identifier: 'sync-width', controllerConstructor: c17},
	{identifier: 'forms--dependend-field-visibility', controllerConstructor: c18},
	{identifier: 'autosubmit', controllerConstructor: c19},
	{identifier: 'tooltip', controllerConstructor: c20},
];
